import React from "react";

import EngineeringIcon from "@mui/icons-material/Engineering";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import EngineeringUserForm from "../../components/EngineeringUserForm.jsx";
import ReadableCurrency from "../../components/ReadableCurrency.jsx";
import PageContext from "../../contexts/PageContext.jsx";
import EngineeringUserProjectDistribution from "./EngineeringUserProjectDistribution.jsx";
import EngineeringUserProjects from "./EngineeringUserProjects.jsx";

function EngineeringUserRow({
  // Props
  user,
  mutate,
}) {
  const { editMode } = React.useContext(PageContext);

  //---------------------------------------------------------------------------
  // States
  //---------------------------------------------------------------------------
  const [expanded, setExpanded] = React.useState(false);
  const ref = React.useRef(null);

  //---------------------------------------------------------------------------
  // Callback Functions
  //---------------------------------------------------------------------------
  const handleExpandClick = React.useCallback(() => {
    setExpanded((previous) => !previous);
  }, [setExpanded]);

  React.useEffect(() => {
    if (expanded) {
      setTimeout(() => {
        const y = ref.current?.getBoundingClientRect().top;
        if (y) {
          window.scrollTo({ top: y + window.scrollY - 70, behavior: "smooth" });
        }
      }, 300);
    }
  }, [expanded]);

  return (
    <Card square ref={ref} sx={{ my: 0.5, ...(expanded && { my: 1, boxShadow: 6 }) }}>
      <Grid
        container
        onClick={handleExpandClick}
        sx={{
          alignItems: "center",
          p: 1,
          cursor: "pointer",
          minHeight: "3.5rem",
          ...(expanded && { fontWeight: "bold" }),
        }}
      >
        <Grid sx={{ display: { xs: "none", sm: "block" } }} size="auto">
          {editMode ? <EngineeringUserForm user={user} mutate={mutate} /> : <EngineeringIcon sx={{ m: 1 }} />}
        </Grid>
        <Grid size="grow" sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ fontWeight: "inherit", ml: 1 }}>{user.name}</Typography>
        </Grid>
        <Grid size={2}>
          <ReadableCurrency value={user.hourlyRate} />
        </Grid>
        <Grid size={2}>
          <Typography sx={{ fontWeight: "inherit" }}>{user.weeklyWorkingHours}</Typography>
        </Grid>
        <Grid size={2}>
          <Typography sx={{ fontWeight: "inherit" }}>{user.weeklyJiraHours}</Typography>
        </Grid>
      </Grid>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider variant="middle" sx={{ my: 1, mx: -1 }} />
        <Box sx={{ m: 2 }}>
          <EngineeringUserProjects user={user} />
        </Box>
        <Box sx={{ m: 2 }}>
          <EngineeringUserProjectDistribution user={user} />
        </Box>
      </Collapse>
    </Card>
  );
}

export default EngineeringUserRow;
